import React, { useState } from "react";
import { FloatingField } from "./FloatingField";
import { IoMdEyeOff, IoMdEye } from "react-icons/io";

/**
 * Reusable password field component with visibility toggle
 * @param {Object} props - All props passed to FloatingField plus showToggle
 */
export const PasswordField = ({
  showToggle = true,
  error,
  ...fieldProps
}) => {
  const [toggleEye, setToggleEye] = useState(false);

  return (
    <div className="relativePos">
      <FloatingField
        {...fieldProps}
        type={toggleEye ? "text" : "password"}
        error={error}
      />
      {showToggle && (
        <div className="anvEye_iconTogle">
          {error ? (
            ""
          ) : !toggleEye ? (
            <IoMdEye onClick={() => setToggleEye((s) => !s)} />
          ) : (
            <IoMdEyeOff onClick={() => setToggleEye((s) => !s)} />
          )}
        </div>
      )}
    </div>
  );
};

